import { selectUseCarExpertCopy } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';

import { CAREXPERT_COPY } from './carexpertCopy';
import { IFieldCopy, IJourneyCopy, IScreenCopy, TScreenKey } from './copyTypes';
import { DEFAULT_COPY } from './defaultCopy';

/** The wording for the partner running this journey. */
export function useCopy(): IJourneyCopy {
    return useAppSelector(selectUseCarExpertCopy)
        ? CAREXPERT_COPY
        : DEFAULT_COPY;
}

/** The heading and subheading for one screen. */
export function useScreenCopy(key: TScreenKey): IScreenCopy {
    return useCopy().screens[key];
}

/** Field and option labels for this partner. */
export function useFieldCopy(): IFieldCopy {
    return useCopy().fields;
}
